import Container from '@material-ui/core/Container';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import React from 'react';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(10, 0),
    backgroundColor: theme.palette.common.white
  },
  title: {
    marginBottom: theme.spacing(7),
    fontSize: 36,
    textTransform: 'uppercase',
    lineHeight: 1.27
  },
  subTitle: {
    marginBottom: theme.spacing(7),
    fontSize: 19,
    fontWeight: 300,
    textTransform: 'uppercase',
    lineHeight: 1.1
  },
  text: {
    marginBottom: theme.spacing(7),
    fontSize: 16,
    fontWeight: 300,
    lineHeight: 1.75,
    '&:last-of-type': {
      marginBottom: 0
    },
    '& a': {
      font: 'inherit',
      textDecoration: 'none',
      color: theme.palette.primary.main,
      '&:hover': {
        textDecoration: 'underline',
        color: theme.palette.primary.dark
      }
    }
  }
}));

const PrivacyPolicyContent = () => {
  const { t } = useTranslation();
  const classes = useStyles({});

  return (
    <section className={classes.root}>
      <Container maxWidth="xl">
        <Typography className={classes.title} variant="h1">
          {t('privacyPolicyPage.title')}
        </Typography>
        <Typography className={classes.text} variant="body1">
          This privacy policy (the “Privacy Policy”) explains ROAR (“ROAR”,
          “we”, “us” or “our”) policies in relation to Personal Information
          collected from users of the ROAR Website.
          <br />
          We take the privacy of users of the ROAR Website seriously. We will
          obtain, retain and process information (including your personal and
          sensitive data) in accordance with the applicable law. We respect your
          right to privacy and we understand that, as a visitor to this ROAR
          Website you prefer to control your own personal information and
          preferences. [For this reason, we may ask you to register or to
          provide personal information and preferences when you visit certain
          areas of the ROAR Website, ROAR mobile application or request
          information.]
          <br />
          This Privacy Policy forms part of the conditions of use of the ROAR
          Website, which can be found at www.theroar.io. By using the ROAR
          Website, the ROAR mobile application and the services on the ROAR
          Website, you consent to the collection and use of your personal data
          by us for the purposes authorized below and for any other purpose,
          which is reasonably necessary for the provision of the proper
          administration of our relationship with you and the ROAR Website.
        </Typography>
        <Typography className={classes.subTitle} variant="h2">
          WHAT INFORMATION DO WE COLLECT?
        </Typography>
        <Typography className={classes.text} variant="body1">
          In general, your use of our website as a site visitor is anonymous: we
          do not engage in any activity that will personally identify our site
          visitors.
        </Typography>
        <Typography className={classes.text} variant="body1">
          We collect Personal Information (such as name, address and e-mail
          address for example) provided by you when you use the ROAR Website and
          other services on the ROAR Website.
          <br />
          In particular, we may collect information from you through the ROAR
          Website in the following circumstances:
          <br />
          When you contact us by email or through the ROAR Website or through
          the ROAR mobile application with any particular comments or inquiries;
          <br />
          When you sign up / register on ROAR website or ROAR mobile
          application;
          <br />
          When you sign-up to the ROAR newsletter; and
          <br />
          When you contact us to receive details about our ROAR product.
        </Typography>
        <Typography className={classes.text} variant="body1">
          Marketing and communications data includes preferences in receiving
          marketing from ROAR and your communications preferences.For more
          details about data collection through the ROAR app see “Use of ROAR
          Application through mobile device” below
          <br />
          We may collect additional information in connection with your
          participation in any promotions or competitions offered by us and
          information you provide when giving us feedback or completing profile
          forms and questionnaires. We also monitor customer traffic patterns
          and the use of the ROAR Website, ROAR mobile application which enables
          us to improve the service we provide.
        </Typography>
        <Typography className={classes.text} variant="body1">
          Personal data, or personal information means any information about an
          individual from which that person can be identified. It does not
          include data where the individual identity has been removed.
        </Typography>
        <Typography className={classes.text} variant="body1">
          Please note that while we do not explicitly collect personal
          information, we will treat any information held in accordance with the
          Data Protection Act 1998 and all applicable laws and regulations
          governing the protection and privacy of personal information.
        </Typography>
        <Typography className={classes.text} variant="body1">
          You have the right to withdraw consent to marketing at any time by
          unsubscribing by emailing us at&nbsp;
          <a href="mailto:info@theroar.io">info@theroar.io</a>
        </Typography>
        <Typography className={classes.text} variant="body1">
          We will only retain your personal information for as long as necessary
          to fulfil the purposes of satisfying any legal, accounting, and/or
          reporting requirements.
        </Typography>
        <Typography className={classes.subTitle} variant="h2">
          HOW DO WE USE THE DATA WE COLLECT?
        </Typography>
        <Typography className={classes.text} variant="body1">
          We use personal information collected from you for the following
          purposes:
          <br />
          To deliver our products and services (including, without limitation,
          the ROAR Mobile Application);
          <br />
          To provide a more personalized service;
          <br />
          To contact you regarding the products or services that you have
          requested;
          <br />
          To respond to any comments or queries you may have;
          <br />
          To carry out auditing, research and analysis in order to maintain,
          protect and enhance the services we provide;
          <br />
          To transfer your details (including account details) to relevant third
          parties, public bodies, industry organizations and regulators as
          reasonably required for the operation of our business; and
          <br />
          To disclose your details to government and associated organizations as
          required by law.
          <br />
          Where you have not objected to such use, we might also use your
          information to let you know about other products and services which we
          offer which may be of interest to you. If you do not object initially,
          but you change your mind later, please email us at:&nbsp;
          <a href="mailto:info@theroar.io">info@theroar.io</a>
        </Typography>
        <Typography className={classes.subTitle} variant="h2">
          CHILDREN UNDER THE AGE OF 13
        </Typography>
        <Typography className={classes.text} variant="body1">
          The ROAR Website and ROAR mobile application is not intended for
          children especially those under 13 years of age. You must be 13 years
          of age or older to register, or use the ROAR website and/or ROAR
          mobile application in any manner. By registering, visiting,
          downloading and using ROAR website and/or ROAR mobile application, you
          represent and warrant to ROAR that you are 13 years of age or older,
          and that you have the right, authority and capacity to use the website
          and/or mobile application.
        </Typography>
        <Typography className={classes.subTitle} variant="h2">
          CHANGES TO OUR POLICY
        </Typography>
        <Typography className={classes.text} variant="body1">
          We reserve the right to make changes to this Privacy Policy at any
          time with or without prior notice by posting new terms on the ROAR
          Website and ROAR mobile application. We will only use information in
          accordance with the Privacy Policy under which the information was
          collected. If you regularly use the ROAR Website you should continue
          to check this Privacy Policy for updates and amendments, as you will
          be deemed to have accepted the changes if you continue to use the ROAR
          Website or ROAR mobile application after any changes have been posted.
        </Typography>
        <Typography className={classes.subTitle} variant="h2">
          HOW DO WE STORE AND MAINTAIN PERSONAL INFORMATION?
        </Typography>
        <Typography className={classes.text} variant="body1">
          All of our employees are subject to obligations of confidentiality
          regarding information which they have access to in the course of their
          employment including the personal information of customers. All
          personal information is held in secure computer storage facilities and
          paper-based files. We take steps to protect the personal information
          we hold from misuse, loss, unauthorized access, modification or
          disclosure.
          <br />
          It may be necessary for us to maintain our records for a number of
          years. However, when information is no longer required, we will
          destroy records containing personal information securely.
        </Typography>
        <Typography className={classes.subTitle} variant="h2">
          DISCLOSURE OF YOUR INFORMATION
        </Typography>
        <Typography className={classes.text} variant="body1">
          As we develop our business we might buy or sell businesses or
          subsidiaries. Where such a transaction occurs, or in the event that we
          are or substantially all of our assets are acquired, the transferred
          assets will generally include customer information but any such
          transfer shall be conditional on this information remaining subject to
          the restrictions on its use as set out in the Privacy Policy notice
          pre-existing the transfer.
          <br />
          We may employ other companies and individuals to carry out functions
          on our behalf including sending mail, providing marketing assistance,
          analyzing data and providing customer service. In order to carry out
          their functions these companies and individuals may require access to
          your personal data but we shall only disclose such relevant personal
          information as is needed by them to perform their functions.
          <br />
          Where requested to do so, we may co-operate with any court, tribunal,
          regulatory body, police authority or other similar authority in any
          investigations or proceedings concerning you or your use of the
          Website. This may include disclosing information about communications
          transmitted via the ROAR Website to such authorities where required.
          <br />
          We may also use and share information relating to groups of customers,
          without identifying individuals, to learn more about customer behavior
          and find ways of enhancing our service.
        </Typography>
        <Typography className={classes.subTitle} variant="h2">
          COOKIES – WHAT ARE THEY AND HOW DO WE USE THEM?
        </Typography>
        <Typography className={classes.text} variant="body1">
          theroar.io may collect certain information by automated means, such as
          cookies and web beacons, when a user visits our website. A “cookie” is
          a small piece of data that a website can send to your browser, which
          may then be stored on your system. For further information on the
          cookies we use on our site and why we use them.
          <br />
          We sometimes collect anonymous information from visits to our website
          to help us provide better customer service. This anonymous information
          is sometimes known as “click stream data”. We may use this data to
          analyze trends and statistics and to help us provide you with a better
          customer service.
          <br />
          We use Google Analytics cookies on our site to enable us to track
          visitor behavior and measure site performance. This helps us to
          improve the way our site works, for example, by ensuring that visitors
          can find what they are looking for easily.
        </Typography>
        <Typography className={classes.text} variant="body1">
          All the data contained in our cookies is completely anonymous and does
          not contain any personally identifiable information. More information
          about Google Analytics cookies can be found at:&nbsp;
          <a href="http://support.google.com/analytics">
            support.google.com/analytics
          </a>
        </Typography>
        <Typography className={classes.text} variant="body1">
          We do not use flash cookies (sometimes known as local shared objects).
          <br />
          Most browsers allow you to turn off the cookie function. If you want
          to know how to do this please look at the help menu on your browser,
          but this may restrict the use of some parts of the Website.
        </Typography>
        <Typography className={classes.subTitle} variant="h2">
          LINKS
        </Typography>
        <Typography className={classes.text} variant="body1">
          The ROAR Website and ROAR application may contain links to other
          websites. Please note that we are not responsible for the privacy
          practices of such other websites, and we recommend you read the
          privacy statements immediately on entering other websites. This
          Privacy Policy applies only to information collected through the ROAR
          Website and ROAR mobile application.
          <br />
          YOUR RIGHTS
          <br />
          IF YOU DO NOT WISH YOUR PERSONAL DATA TO BE USED IN THE MANNER SET OUT
          IN THIS PRIVACY POLICY PLEASE EXIT the ROAR Website and ROAR mobile
          application IMMEDIATELY AND DO NOT USE the ROAR Website or ROAR mobile
          application IN THE
        </Typography>
        <Typography className={classes.subTitle} variant="h2">
          FUTURE
        </Typography>
        <Typography className={classes.text} variant="body1">
          You have the right to obtain a copy of any personal information, which
          we hold, about you and to notify us of any inaccuracies. If you would
          like to obtain a copy of your personal information please write to us
          using the address provided in this Privacy Policy. You will need to
          verify your identity and specify what information you require. We may
          charge you a fee to cover our costs incurred in providing you with a
          copy of your information.
          <br />
          We will be happy to answer any inquiries from you regarding this
          Privacy Policy, the personal data we hold about you or the use we make
          of it. If you have any queries, comments, or if you wish to correct or
          update the data we hold about you, please email us at:&nbsp;
          <a href="mailto:info@theroar.io">info@theroar.io</a>
        </Typography>
        <Typography className={classes.subTitle} variant="h2">
          JURISDICTION
        </Typography>
        <Typography className={classes.text} variant="body1">
          This Privacy Policy shall be governed by and construed in accordance
          with the laws of the State of New Jersey, USA applicable to agreements
          made and to be entirely performed within the State of New Jersey (even
          if your use is outside of the State of New Jersey), without resort to
          its conflict of law provisions. You agree that any action at law or in
          equity arising out of or relating to this website or these terms shall
          be filed only in the state or federal courts located in the State of
          New Jersey and you hereby irrevocably and unconditionally consent and
          submit to the exclusive jurisdiction of such courts.
          <br />
          USE OF ROAR APPLICATION THROUGH MOBILE DEVICE
          <br />
          This Privacy Policy applies to our collection and processing of
          personal data through the ROAR Mobile Application.
          <br />
          Through the Mobile Application, we may collect mobile device
          identifiers, such as device type, IP address, operating system and
          your geographic location. If you choose to activate Facebook or
          Twitter on the ROAR application, we may also collect your name, sex,
          occupation and/or any other personal information you have provided to
          Facebook or Twitter.
        </Typography>
      </Container>
    </section>
  );
};

export default PrivacyPolicyContent;
